"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleCarFrontIcon.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleCarFrontIcon = function CircleCarFrontIcon(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 200 200"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Car Front Circle Icon"), _react2.default.createElement("g", {
    className: "car-front-icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M144 86.11a26 26 0 0 1 9 1.66l-8.5-17.43c-4.23-12.56-8.4-17.23-15.89-17.23H72.47c-7.55 0-11.27 4.24-15.91 17.31L47.8 87.35a26.23 26.23 0 0 1 8.2-1.24h88zm-25.29 25H82.59a3 3 0 1 0 0 6h36.11a3 3 0 1 0 .01-6zm-54.85-3H48.33a5 5 0 1 0 0 10h15.53a5 5 0 1 0 0-10z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M100 0a100 100 0 1 0 100 100A100 100 0 0 0 100 0zm67.15 115.14a17.54 17.54 0 0 1-.47 4.06 7.09 7.09 0 0 1 .47 2.54v26.71c0 3.92-3.3 6.66-7.22 6.66h-13.87a6.58 6.58 0 0 1-6.9-6.66v-13.34h-77v13.34c0 3.92-3.46 6.66-7.37 6.66H40.07a6.59 6.59 0 0 1-6.91-6.66v-26.72a7 7 0 0 1 .48-2.54 17.44 17.44 0 0 1-.48-4.06v-9a17.77 17.77 0 0 1 2.67-9.48L48 67.58c4.16-11.79 9.44-23.47 24.5-23.47h56.19c14.7 0 20.5 11.4 24.57 23.54l.05.35L165 96.9c.16.59.35 1.2.46 1.78a17.75 17.75 0 0 1 1.74 7.48v9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M151.27 108.11h-15.52a5 5 0 1 0 0 10h15.52a5 5 0 1 0 0-10z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: undefined
  })));
};
exports.default = CircleCarFrontIcon;